const type = 'SET_MIN_UPFRONT_AMOUNT_SPLIT_INVOICE';

const setMinUpfrontAmountSplitInvoice = (data = {}) => ({
  data,
  type,
});

export { type };
export default setMinUpfrontAmountSplitInvoice;
